import React, { useState, useEffect, useContext, useCallback, memo } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import Modal from 'react-modal'
import axios from 'axios'

import NewProjectModal from '../../components/NewProjectModal'
import SideBar from '../../components/SideBar'
import TitleBar from '../../components/TitleBar.jsx'
import {
  projectContext,
  loadingContext,
  spaceRemover,
  msalConfig,
  encrypter,
  unfolder,
  urlValue,
  closeModalVw,
  openModalVw,
  useTranslate
} from '../../lib'

import '../../styles/home.scss'
import { customModal } from '../../styles/customModal'
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import axio from "axios";
import { getCookie, setCookie } from '../../lib/index'
import NewCampaingModal from '../../components/NewCampaingModal'
import EditCampaingModal from '../../components/EditCampaingModal'
import EditSubCampaingModal from '../../components/EditSubCampaingModal'
import NewSubCampaingModal from '../../components/NewSubCampaingModal'
import CheckBox from '../../components/CheckBox'
import CheckBox2 from '../../components/CheckBox2'
import ModalVw, { ModalBody, ModalContent, ModalHeader } from '../../components/common/ModalVw'
import NewProjectView from '../../components/NewProjectView'
import Loading from '../../components/Loading'
// import toltipIcon from '../../img/icons/tooltip-indicator-icon.svg';
import { Tooltip, } from 'react-tooltip'
import 'react-tooltip/dist/react-tooltip.css'
import ModeProject from '../../components/ProjectGenAI/ModeProject'
import ProjectViewGenAi from '../../components/ProjectGenAI/ProjectViewGenAi'
import Button from '../../components/provider/button/button.jsx'
import Search from '../../components/provider/search/search.jsx'
import Tutor from '../../components/common/Tutor/Tutor.jsx';

const HomeGenAI = () => {

  const [campaings, setCampaings] = useState([])
  const [projects, setProjects] = useState([])
  const [searchCampaigns, setSearchCampaigns] = useState('')
  const [searchProjects, setSearchProjects] = useState('')
  const [about, setAbout] = useState([
    'With the right knowledge and tools, everyone can land their dream job. In this quiz, you will learn to strengthen your knowledge and expand your skills.',
  ])
  const [isModalOpen, setIsModalOpen] = useState({
    modeProject: false,
    newProjectGenAi: false,
    error: false,
    newProject: false,
    newCampaing: false,
    newSubCampaing: false,
    drop: false,
    edit: false,
  })
  const [isModalCampOpen, setIsModalCampOpen] = useState({
    cam: false,
    campaing: null,
    error: false,
    newCampaing: false,
    drop: false,
    edit: false,
  })
  const [camp, setCamp] = useState(null)
  const [projectId, setProjectId] = useState(null)
  const navigate = useNavigate()
  const [loading, setLoading] = useContext(loadingContext)
  const [selectedProject, setSelectedProject] = useContext(projectContext)
  const [refresh, setRefresh] = useState(false)
  const [modalDeleProj, setModalDeleProj] = useState(false)
  const [modalDeleCamp, setModalDeleCamp] = useState({ id: null, visible: false })
  const [modalDeleSubCamp, setModalDeleSubCamp] = useState({ id: null, visible: false })
  const [expandedCampaigns, setExpandedCampaigns] = useState(new Set());
  const [expandedRegions, setExpandedRegions] = useState(new Set());
  const [role, setRole] = useState(0)
  const { t } = useTranslate();
  const regions = [{id: 1, name:'LATAM'}, {id: 2, name:'CSC'}, {id: 3, name:'CAN'}, {id: 4, name:'Off-Shore'}]
  
  const tutorialSteps = [
      { elementId: 'con-search-campaign', text: t('tutorial.searchCampaign')},
      { elementId: 'btn-campaign', text: t('tutorial.createCampaign') },
      { elementId: 'btn-sub-campaign', text: t('tutorial.addSubCampaign') },
      { elementId: 'new-project', text: t('tutorial.createProject') },
      { elementId: 'project-access', text: t('tutorial.projectAccess') },
      { elementId: 'delete-project', text: t('tutorial.projectDelete') },
  ];

  const openAllCampaing = () => {
    document.querySelectorAll(".sub-campaing-name").forEach((e, i) => {
      e.addEventListener("click", function () {
        document.querySelectorAll(".sub-campaing-name").forEach((e, i) => { e.classList.remove("select-item") });
        e.classList.toggle("select-item")
      })
    })


    document.querySelectorAll(".acordion").forEach((element, i) => {
      element.addEventListener("click", openCampaing)
      // document.querySelector("#deletec" + i).addEventListener("click", function (e) {
      //  e.stopPropagation();
      // })
      // document.querySelector("#editc" + i).addEventListener("click", function (e) {

      // })
    })


  }
  const fetchCampaings = async () => {

    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    setLoading(true)
    const url = `${urlValue}/studio/project/camp/sub-and-campaing`;

    const result = await axios.get(url, {
      headers: {
        'user': id,
        'access-token': token,
      },
    });

    if (result.status === 200 && result.data) {
      setCampaings(result.data.data)
      setTimeout(() => {
        openAllCampaing()
      }, 1000);
    }
  }
  useEffect(() => {
    setRole(unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').role)
    fetchCampaings();
  }, []);
  //Carousel Config
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };

  useEffect(() => setLoading(false), [])
  useEffect(() => {
  }, [refresh])

  const getProjects = asignedProjects => {
    setSelectedProject('')
    setProjects([])
    asignedProjects.map(({ project }) => {
      setLoading(true)
      let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id

      let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
      axios({
        method: 'get',
        url: `${urlValue}/studio/project/${project}`,
        headers: {
          'access-token': token,
          user: id
        },
      })
        .then(function (response) {

          setProjects(result => [...result, response.data])
          setLoading(false)
        })
        .catch(function (error) {
          console.log(error)
          setLoading(false)
        })
    })
  }

  const handleNavigate = e => {
    // let name = spaceRemover(e.target.parentNode.previousElementSibling.innerText)
    let name = spaceRemover(e.target.previousElementSibling.innerText)
    let selectProject = projects.filter(e => spaceRemover(e.name) == name)[0]
    if (selectProject.metadata) {
      localStorage.setItem(
        'HashSelectedProject',
        encrypter(selectProject, 'IANestingKey')
      )
      setSelectedProject(selectProject)
      if (selectProject.type === "GEN AI") {
        navigate(`/${name}/GenAI`)
      } else {
        navigate(`/${name}`)
      }
    } else {
      setIsModalOpen({ error: true, newProject: false })
    }
  }

  const handleOpen = (id) => {
    setProjectId(id)
    setIsModalOpen({ drop: true, edit: false })
  }

  const closeModal = () => {
    setIsModalOpen({ error: false, newProject: false })
  }
  const closeModalCamp = () => {
    setIsModalCampOpen({ campaing: null, error: false, newCampaing: false, edit: false })
  }
  const handleClose = () => setIsModalOpen({ drop: false, edit: false })

  const deleteProject = async () => {
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let csrfToken = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').csrfToken
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id

    try {
      const url = `${urlValue}/studio/project/${projectId}`;

      const rest = await axio.delete(url, {
        data: { id: id },
        headers: {
          'user': id,
          'access-token': token,
          'Content-Type': 'application/json',
          'X-CSRF-Token': csrfToken
        },
        withCredentials: true,
      });

      if (rest.status === 200) {
        setIsModalOpen({ drop: false, edit: false });
        setRefresh(true)
      } else {
        setIsModalOpen({ drop: false, edit: false })
      }

    } catch (error) {
      console.log("error ", error)
      setIsModalOpen({ drop: false, edit: false })
    }
  }

  const eventAdd = (e) => {
    e.addEventListener("click", function (e) {
      e.classList.toggle("active");
      var panel = e.nextElementSibling;
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      }
    })
  }

  const openRegion = (event, regionId) => { 
    
    setExpandedRegions(prev => {
      const newSet = new Set(prev);
      if (newSet.has(regionId)) {
        newSet.delete(regionId);
      } else {
        newSet.add(regionId);
      }
      return newSet;
    });
  };

  const openCampaing = (event, campaignId) => { 
    if (isModalOpen.edit) return;

    if (
      event.target.closest('.icon-trash') ||
      event.target.closest('img[id^="editc"]')
    ) {
      return;
    }

    setExpandedCampaigns(prev => {
      const newSet = new Set(prev);
      if (newSet.has(campaignId)) {
        newSet.delete(campaignId);
      } else {
        newSet.add(campaignId);
      }
      return newSet;
    });
  };
 

  const selectProj = async (subcamp) => {
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token

    const url = `${urlValue}/studio/project/camp/project-subcampaing/${subcamp.sub_campaing_id}/${subcamp.campaing_id}`;
    const result = await axios.get(url, {
      headers: {
        'user': id,
        'access-token': token,
      },

    });
    
    if (result.status === 200 && result.data) {
      setProjects(result.data.data)
      setProjectsDelete([])
    }
  }

  const selectCampaignRegion = async (region_id) => {
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token

    const url = `${urlValue}/studio/campaign/campaignregion/${region_id}`;
    const result = await axios.get(url, {
      headers: {
        user: id,
        'access-token': token,
        'Content-Type': 'application/json',
        'region_id': region_id
      },

    });
    if (result.status === 200 && result.data) {
      setCampaings(result.data)
      setProjects([])
      setProjectsDelete([])
    }
  }

  const selectProjCmap = async (camping) => {
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token

    const url = `${urlValue}/studio/project/camp/project-campaing/${camping.campaing_id}`;
    const result = await axios.get(url, {
      headers: {
        'user': id,
        'access-token': token,
      },

    });

    if (result.status === 200 && result.data) {
      setProjects(result.data.data)
      setProjectsDelete([])
    }
  }
  const deleteCamp = (camp) => {
    setModalDeleCamp({ ...modalDeleCamp, id: camp.id, visible: true })
  }
  const deleteSubCamp = (subcamp) => {
    if (camp.campaing_name) {
      setModalDeleSubCamp({ ...modalDeleSubCamp, id: subcamp.id, visible: true })
    }
  }
  const selectCamp = (camp) => {
    selectProjCmap(camp)
  }
  const [projectsDelete, setProjectsDelete] = useState([]);
  const selectForDelete = (e, item) => {
    if (e.target.checked) {
      setProjectsDelete([...projectsDelete, item])
    } else {
      setProjectsDelete(projectsDelete.filter(x => x.id !== item.id));
    }
  }

  const selectAll = (e) => {
    if (e.target.checked) {
      document.querySelectorAll("#project-all input[type='checkbox']").forEach((item) => {
        item.checked = true;
      })
    } else {
      document.querySelectorAll("#project-all input[type='checkbox']").forEach((item) => {
        item.checked = false;
      })
    }
  }

  const deleteCampaign = async () => {
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let csrfToken = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').csrfToken
    let result = await axios.delete(`${urlValue}/studio/project/campaign/${modalDeleCamp.id}`, {
      headers: {
        'user': id,
        'access-token': token,
        'X-CSRF-Token': csrfToken
      },
      withCredentials: true,
    });
    setModalDeleCamp({ ...modalDeleCamp, id: null, visible: false })
    window.location.reload();
  }

  const deleteSubCampaign = async () => {
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let csrfToken = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').csrfToken
    let result = await axios.delete(`${urlValue}/studio/project/subcampaign/${modalDeleSubCamp.id}`, {
      headers: {
        'user': id,
        'access-token': token,
        'X-CSRF-Token': csrfToken
      },
      withCredentials: true,
    });
    setModalDeleSubCamp({ ...modalDeleSubCamp, id: null, visible: false })
    window.location.reload();
  }

  const deleteMultiple = async () => {
    try {
      if (projectsDelete.length > 0) {

        let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
        let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
        let csrfToken = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').csrfToken
        let result;
        for (let i = 0; i < projectsDelete.length; i++) {
          result = await axios.delete(`${urlValue}/studio/project/${projectsDelete[i].id}`, {
            headers: {
              'user': id,
              'access-token': token,
              'X-CSRF-Token': csrfToken
            },
            withCredentials: true,
          });
        }
        setModalDeleProj(false)
        window.location.reload();
      }
    } catch (error) {
      setModalDeleProj(false)
    }
  }

  useEffect(() => {
    document.querySelectorAll("#project-all input[type='checkbox']").forEach((item) => {
      item.checked = false;
    })
  }, [projects])

  const openType = (type) => {
    if (type === "GEN AI") {
      openModalVw("#projectgenai-modal", () => setIsModalOpen({ ...isModalOpen, newProjectGenAi: true }))
    } else {
      openModalVw("#project-modal", () => setIsModalOpen({ ...isModalOpen, newProject: true }))
    }
  }

  const handleSearchCampaigns = (searchValue) => {
    setSearchCampaigns(searchValue);
    
    if (searchValue.trim() !== '') {
      const campaignsToExpand = new Set();
      
      campaings.forEach(camp => {
        const subCampaignMatch = camp.sub_campaing.some(subcamp => 
          (subcamp.sub_campaing_name || "Unasigned").toLowerCase().includes(searchValue.toLowerCase())
        );
        
        if (subCampaignMatch) {
          campaignsToExpand.add(camp.id);
        }
      });
      
      if (campaignsToExpand.size > 0) {
        setExpandedCampaigns(prev => new Set([...prev, ...campaignsToExpand]));
      }
    }
  }

  return (
    <>
      <div className="container-home general-container d-flex flex-row justify-space-center" id="container-home">
        {/* <SideBar project={false} /> */}
        <div className="d-flex flex-column" style={{ flex: 1 }}>
          <TitleBar />
          <div className="actions">
            {/*<div className="search">*/}
            {/*  <input*/}
            {/*    type="text"*/}
            {/*    placeholder="Search Project"*/}
            {/*    onChange={event => {*/}
            {/*      setSearch(event.target.value)*/}
            {/*    }}*/}
            {/*  />*/}
            {/*  <img src="/icons/magnifying.png" alt="magnifying" />*/}
            {/*</div>*/}
            {/*<div*/}
            {/*  className="newProject"*/}
            {/*  onClick={() =>  openModalVw("#project-modal", () => setIsModalOpen({ ...isModalOpen, error: false, newProject: true } )) }*/}
            {/*>*/}
            {/*  <img src="/icons/new.png" alt="newAns" />*/}
            {/*  <span>New Projects</span>*/}

            {/*</div>*/}
            {/*<div*/}
            {/*  className="newProject"*/}
            {/*  onClick={() => { setIsModalCampOpen({ error: false, newCampaing: true, edit: false }) }}*/}
            {/*>*/}
            {/*  <img src="/icons/new.png" alt="newAns" />*/}
            {/*  <span>New Account</span>*/}

            {/*</div>*/}

            {/*<div*/}
            {/*  className="newProject"*/}
            {/*  onClick={() => setIsModalOpen({ error: false, newSubCampaing: true })}*/}
            {/*>*/}
            {/*  <img src="/icons/new.png" alt="newAns" />*/}
            {/*  <span>New Sub Account</span>*/}
            {/*</div> */}

          </div>

          <div className="d-flex flex-row flex-wrap mt-1" style={{}}>
            <div className='left-home panel-left panel-c ' style={{ overflowY: "hidden", height: "auto", flex: '1 1 auto' }}>

              <div className="d-flex flex-row align-items-center justify-space-between " style={{ marginBottom: 15 }}>
                <div id='con-search-campaign' className=" home-search bg-white d-flex flex-row align-items-center justify-space-between"
                  style={{ borderRadius: 20, backgroundColor: 'white', width: 215, border: '1px solid gray' }}>
{/*
                  <Search placeholder={'Search'} onChange={event => {setSearch(event.target.value)}} />
*/}
                  <input
                    type="text"
                    placeholder={t('common.search')}
                    onChange={event => {
                      handleSearchCampaigns(event.target.value)
                    }}
                    style={{ border: 'none', marginLeft: 7, maxWidth: 160, borderRadius: '20px' }}
                    className="p-2 home-search"
                  />
                  <div className="p-1 pr-4 mt-1">
                    <img src="/icons/search.svg" style={{ width: 16, marginLeft: "-8px", minWidth: 16 }} alt="magnifying" />
                  </div>
                </div>
                <div className="d-flex flex-row align-items-center">
                  <div className='tooltip-div'>
                    <img id="campaing-tp" src="/icons/tooltip-indicator-icon.svg" className="cursor-pointer tooltip-nesting  " alt="" />
                    <Button 
                      label={t('menu.newCampaign')}
                      onClick={() => openModalVw("#newcp-modal", () => setIsModalCampOpen({ ...isModalCampOpen, cam: true }))}
                      className='buttonE' id="btn-campaign"
                    />
                    {/*
                    <button onClick={() => openModalVw("#newcp-modal", () => setIsModalCampOpen({ ...isModalCampOpen, cam: true }))}
                      className='button-setup   camp-btn' type="button" style={{ borderRadius: 20, backgroundColor: '#0038A8' }}
                    >New Campaign</button>
                    */}
                    <Tooltip events={['click']} anchorId="campaing-tp" 
                      html={t('menu.newcampaignTooltip')} place="top" />
                  </div>
                  <div className='tooltip-div' style={{ marginLeft: 12 }}>
                    <img id="sub-campaing-tp" src="/icons/tooltip-indicator-icon.svg" className="cursor-pointer tooltip-nesting  " alt="" />
                    <Button 
                      label={t('menu.newSubCampaign')}
                      onClick={() => openModalVw("#sbnewcp-modal", () => setIsModalOpen({ ...isModalOpen, newSubCampaing: true }))}
                      className='buttonF' id="btn-sub-campaign"
                    >
                      {t('menu.newSubCampaign')}
                    </Button>
                    <Tooltip events={['click']} anchorId="sub-campaing-tp" 
                      html={t('menu.newSubcampaignTooltip')} place="top" />
                  </div>
                </div>

              </div>


              <div className='list-l-nesting'>
                {campaings
                  ?.filter(camp => {
                    if (searchCampaigns === '') {
                      return true;
                    } else {
                      const campaignMatch = (camp.campaing_name || "Unasigned").toLowerCase().includes(searchCampaigns.toLowerCase());
                      
                      const subCampaignMatch = camp.sub_campaing.some(subcamp => 
                        (subcamp.sub_campaing_name || "Unasigned").toLowerCase().includes(searchCampaigns.toLowerCase())
                      );
                      
                      return campaignMatch || subCampaignMatch;
                    }
                  })
                  ?.map((camp, i) => {

                    const isExpanded = expandedCampaigns.has(camp.id);

                  return (
                    <div key={`${camp.id}-${i}`} className='list-campaing accordion'>
                      <div 
                        onClick={(e) => {
                          if (!e.target.closest('.icon-trash') && !e.target.closest('img[id^="editc"]')) {
                            selectCamp(camp);
                            openCampaing(e, camp.id);
                          }
                        }}  
                        className='acordion campaing-name flex items-center'>

                          <div className='d-flex flex-row align-items-center'>{camp.campaing_name ?? t('common.unasigned')}
                            {/* <img id={"editc" + i} onClick={() => { openModalVw("#campedit-modal", () => setIsModalCampOpen({ ...isModalCampOpen, campaing: camp, edit: true })) }} src="/icons/EditarIcon.svg" style={{ marginLeft: 15, width: 18 }} alt="" /> */}
                          </div>
                          {/* <Tooltip anchorId={"editc" + i} content={`Edit`} place="top" /> */}

                          <div className='flex items-center'  >
                            {/* <a href={`/campaign/${camp?.campaing_id}/customizable/${camp?.campaing_name}`} target="_blank" rel="noopener noreferrer">
                              <img id={"customizec" + i} className="icon-trash" src="/icons/customize-campaign.svg" alt='' />
                            </a> */}
                            
                            {role === 6 && <img id={"deletec" + i} onClick={(e) => { deleteCamp(camp) }} className="icon-trash" src="/icons/trash-1.png" alt='' />}
                            <img 
                              className="icon-arrow" 
                              src="/icons/chevron-right.svg" 
                              alt='' 
                              style={{
                                transform: isExpanded ? 'rotate(270deg)' : 'rotate(0deg)',
                                transition: 'transform 0.3s ease'
                              }}
                            />
                          </div>
                          <Tooltip anchorId={"deletec" + i} content={t('common.delete')} place="top" />

                      </div>
                      <ul className={`list-sub-campaing ${isExpanded ? 'expanded' : 'collapsed'}`}
                        style={{ 
                          maxHeight: isExpanded ? 'none' : '0',
                          overflow: 'hidden',
                          transition: 'max-height 0.3s ease',
                          display: isExpanded ? 'block' : 'none'
                        }}>
                        {camp.sub_campaing
                          .map((subcamp, index) => {
                            const matchesSearch = searchCampaigns === '' || 
                              (subcamp.sub_campaing_name || "Unasigned").toLowerCase().includes(searchCampaigns.toLowerCase());
                            return (
                              <li key={`${subcamp.id}-${index}`} onClick={() => { selectProj(subcamp) }} 
                                className='sub-campaing-name flex items-center'
                                style={{ 
                                  fontWeight: matchesSearch && searchCampaigns !== '' ? 'bold' : 'normal'
                                }}>
                                <div className='flex  items-center' style={{ flex: 1 }}>
                                  <span>{subcamp.sub_campaing_name ?? t('common.unasigned')}</span>
                                  {/* <img id={"editsc" + i} onClick={() => { openModalVw("#sbcampedit-modal", () => setIsModalOpen({ ...isModalOpen, subcampaing: subcamp, edit: true })) }} src="/icons/EditarIcon.svg" style={{ marginLeft: 15, width: 18 }} alt="" />
                                  <Tooltip anchorId={"editsc" + i} content={t('common.edit')} place="top" /> */}
                                </div>
                                <div className='flex  items-center'  >
                                  {role === 6 && <img style={{ marginRight: 10 }} id={"deletesc" + i} onClick={() => deleteSubCamp(subcamp)} className="icon-trash" src="/icons/trash-1.png" alt='' />}
                                  {role === 6 && <Tooltip anchorId={"deletesc" + i} content={t('common.delete')} place="top" />}
                                  <span id={"content" + i} style={{ fontSize: 14, color: '#707070' }}> {t('common.content')}</span>
                                  <Tooltip anchorId={"content" + i} content={t('menu.displaySubCampaignTooltip')} place="top" />
                                  <img id={"content" + i} style={{ marginLeft: 15, width: 9, transform: "rotate(0deg)" }} className="icon-arrow" src="/icons/chevron-right.svg" alt='' />
                                </div>
                              </li>
                            )
                          }
                        )}
                      </ul>
                    </div>
                    )
                })}
                      
              </div>
            </div>
            <div className='rigth-home panel-c' style={{ overflowY: "hidden", overflowX: 'visible', height: "auto", flex: '1 1 auto', minWidth: 0 }}>
              <div className="d-flex flex-row align-items-center justify-space-between" style={{ marginBottom: 15, flexWrap: 'wrap', gap: '8px' }}>
                <div className="home-search-r bg-white d-flex flex-row align-items-center justify-space-between"
                  style={{ borderRadius: 20, backgroundColor: 'white', width: 215, border: '1px solid gray', minWidth: 180, flexShrink: 0 }}>
                  <input
                    type="text"
                    placeholder={t('common.search')}
                    onChange={event => {
                      setSearchProjects(event.target.value)
                    }}
                    style={{ border: 'none', marginLeft: 7, maxWidth: 160, borderRadius: '20px' }}
                    className="p-2"
                  />
                  <div className="p-1 mr-3 mt-1">
                    <img src="/icons/search.svg" style={{ width: 16, marginLeft: "-8px", minWidth: 16 }} alt="magnifying" />
                  </div>
                </div>
                <div className="ml-3 d-flex flex-row align-items-center" style={{ flexWrap: 'wrap', gap: '8px', flexShrink: 0 }}>
                  <Button 
                      id="new-project"
                      label={t('menu.newProject')}
                      onClick={() => openModalVw("#mode-proj-modal", () => setIsModalOpen({ ...isModalOpen, error: false, modeProject: true }))
                      }
                      className='buttonE'
                      style={{ whiteSpace: 'nowrap', minWidth: 'auto', width: 'auto' }}
                  />
                  <Tooltip anchorId="new-project" content={t('menu.newProjectTooltip')} place="top" />

                  {/* <Link to={'/project-access'} id='project-access' className='buttonH' style={{fontSize: 13, whiteSpace: 'nowrap', minWidth: 'auto', width: 'auto', textDecoration: 'none'}}>
                    {t('menu.projectAccess')}
                  </Link>
                  <Tooltip anchorId="project-access" content={t('menu.projectAccessTooltip')} place="top" /> */}

                  <Button 
                      id='delete-project'
                      label={t('common.delete')}
                      onClick={() => setModalDeleProj(true)}
                      className='buttonH'
                      style={{ whiteSpace: 'nowrap', minWidth: 'auto', width: 'auto' }}
                  />
                  {/** 
                  <button id='delete-project' onClick={() => setModalDeleProj(true)}
                    className='button-setup btn-all' type="button" style={{ borderRadius: 20, backgroundColor: '#0038A8', marginLeft: 10, width: 118 }}>
                    Delete
                  </button>
                  */}
                  <Tooltip anchorId="delete-project" content={t('menu.deleteProjectsTooltip')} place="top" />
                </div>

              </div>

              {projects.length > 0 &&

                <div className='rounded-md panel-delete flex items-center' style={{ backgroundColor: "transparent", paddingLeft: 0 }}>
                  <CheckBox2 onChange={(e) => selectAll(e)} default={false} id={`ck-all-proj`} text="" />
                  <div style={{ fontSize: 14, color: '#575756' }}>{t('menu.selectAllProjects')}</div>
                  {/*<img id="deletecAll" onClick={() => setModalDeleProj(true)} className="icon-trash" src="/icons/trash-1.png" alt="" style={{ width: 21 }} />*/}
                  {/*<labe><b></b>Delete</labe>*/}
                </div>}
              <div id="project-all  " className='list-r-nesting'>
                {projects
                  .filter(item => {
                    if (searchProjects === '') {
                      return true;
                    } else {
                      return item.name.toLowerCase().includes(searchProjects.toLowerCase());
                    }
                  })
                  .map((item, i) => (
                  <div key={i} onMouseEnter={() => setAbout(item.metadata?.description || "")} className='project-cont flex items-center' style={{ position: 'relative' }}>
                    <CheckBox2 onChange={(e) => selectForDelete(e, item)} default={false} id={`${item.name}-${item.id}`} text="" />
                    {item.image && typeof item?.image === 'string' && item.image.startsWith('https://campaign-logos-nesting.s3.amazonaws.com') ? <img src={item.image} alt='' style={{ width: '47px', 'borderRadius': '7px', 'margin-right': '15px' }}></img> : ''}
                    <span className='flex items-center' style={{ flex: 1 }}><p>{item.name}</p>  {item.type === 'GEN AI' && <img src='/icons/GenAI-projectgenerated-icon.svg' alt="" style={{ width: '22px', marginLeft: '9px' }} />}</span>
                    {/* <Button 
                        id={"setupp" + i}
                        label='Set up'
                        onClick={handleNavigate}
                        className='buttonG ml-3'
                        data-name={item.name}
                    /> */}
                     
                    <button id={"setupp" + i} onClick={handleNavigate} className='button-setup setup-btn' style={{fontWeight: 400}} type="button">
                      {t('common.setUp')}
                    </button>
                   
                    <Tooltip anchorId={"setupp" + i} content={t('menu.goToProjectSettings')} place="top" />
                  </div>
                ))}
              </div>
            </div>

          </div>
          <div className=" d-flex flex-row flex-wrap justify-space-between w-100 mt-1" style={{ display: "none", overflowY: "scroll", overflowX: "hidden" }}>
            {false && projects
              .filter(value => {
                if (searchProjects == '') {
                  return value
                } else if (value.name.toLowerCase().includes(searchProjects.toLowerCase())) {
                  return value
                }
              })
              .map(({ id, name, metadata }, index) => (
                <div
                  className="pl-1 pr-1 pt-1 pb-1 mt-1 d-flex flex-row align-items-center justify-space-between"
                  style={{ overflowX: "hidden", backgroundColor: "rgb(239 239 239)", borderRadius: 5, margin: 2, width: '47%', minWidth: 290 }}
                  key={index}
                  onMouseEnter={() => setAbout(metadata.description)}
                >
                  <div className="d-flex flex-row align-items-center" style={{ overflowX: 'hidden', flex: 1 }}>
                    <span style={{ fontSize: 20, fontWeight: 800, color: "#545454" }}>{name} </span>
                    <span className="ml-2 mr-2" style={{ fontSize: 25, color: "#545454" }}>|</span>
                    <div className="w-100" style={{ letterSpacing: 1, wordWrap: 'break-word', overflowX: 'hidden', fontSize: 14, fontWeight: 600, color: "#727272", whiteSpace: "normal" }}>
                      {metadata.description}
                    </div>
                  </div>
                  <button onClick={() => handleOpen(id)} className="button ml-1" style={{ cursor: 'pointer', border: 'none' }}>
                    <span className="material-icons" style={{ color: "#0087ff", fontSize: 26 }}>delete_outline</span>
                  </button>
                  <span style={{ display: 'none' }}>{name}</span>
                  <button onClick={handleNavigate} className="pl-3 pr-3 pt-1 pb-1 ml-1 "
                    style={{ borderRadius: 15, border: "1px solid #0087ff", color: "#0087ff", fontSize: 16, fontWeight: 700, cursor: 'pointer' }}>
                    {t('common.setUp')}
                  </button>
                </div>
              ))}
          </div>
        </div>
      </div>

      <Modal isOpen={isModalOpen.drop} onClose={handleClose} style={customModal} ariaHideApp={false}>
        <div id="container-modal" className='modal-c'>
          <img src="/icons/alert.png" alt='' />
          <h1>{t('menu.deleteProjectsModal')}</h1>
          <h1>{t('menu.deleteConfirmQuestion')}</h1>
          <div className="buttons-modal">
            <button
              onClick={handleClose}
              className="cancel btn-modal-cancel"
            >
              {t('common.cancel')}
            </button>
            <button onClick={deleteProject} className="accept">
              {t('common.yes')}
            </button>
          </div>
        </div>
      </Modal>

      <Modal isOpen={modalDeleProj} style={customModal} ariaHideApp={false}>
        <div id="container-modal" className='modal-c'>
          <img src="/icons/alert.png" alt='' />
          <h1>{t('menu.deleteProjectsModal')}</h1>
          <h1>{t('menu.deleteConfirmQuestion')}</h1>
          <div className="buttons-modal">
            <button
              onClick={() => setModalDeleProj(false)}
              className="cancel btn-modal-cancel"
            >
              {t('common.cancel')}
            </button>
            <button onClick={() => { deleteMultiple() }} className="accept">
              {t('common.yes')}
            </button>
          </div>
        </div>
      </Modal>
      <Modal isOpen={modalDeleCamp.visible} style={customModal} ariaHideApp={false}>
        <div id="container-modal" className='modal-c'>
          <img src="/icons/alert.png" alt='' />
          <h1>{t('menu.deleteCampaignModal')}</h1>
          <h1>{t('menu.deleteConfirmQuestion')}</h1>
          <div className="buttons-modal">
            <button
              onClick={() => setModalDeleCamp({ id: null, visible: false })}
              className="cancel  btn-modal-cancel"
            >
              {t('common.cancel')}
            </button>
            <button onClick={() => { deleteCampaign() }} className="accept">
              {t('common.accept')}
            </button>
          </div>
        </div>
      </Modal>

      {/* <Modal isOpen={isModalOpen.delete} style={customModal} ariaHideApp={false}>
        <div id="container-modal" className='modal-c'>
          <img src="/icons/alert.png" />
          <h1>You are about to delete an Intent.</h1>
          <h1>{t('menu.deleteConfirmQuestion')}</h1>
          <div className="buttons-modal">
            <button
              onClick={() => setIsModalOpen({ delete: false, code: false })}
              className="cancel btn-modal-cancel"
            >
              Cancel
            </button>
            <button onClick={deleteAnswer} className="accept">
              {t('common.accept')}
            </button>
          </div>
        </div>
      </Modal> */}

      <Modal isOpen={modalDeleSubCamp.visible} style={customModal} ariaHideApp={false}>
        <div id="container-modal" className='modal-c'>
          <img src="/icons/alert.png" alt='' />
          <h1>{t('menu.deleteSubCampaignModal')}</h1>
          <h1>{t('menu.deleteConfirmQuestion')}</h1>
          <div className="buttons-modal">
            <button
              onClick={() => setModalDeleProj(false)}
              className="cancel btn-modal-cancel"
            >
              {t('common.cancel')}
            </button>
            <button onClick={() => { deleteSubCamp() }} className="accept">
            {t('common.accept')}
            </button>
          </div>
        </div>
      </Modal>
      <Modal isOpen={isModalOpen.error} style={customModal} ariaHideApp={false}>
        <div id="container-modal">
          <img src="/icons/alert.png" alt="" />
          <h1>{t('menu.noDataProvided')}</h1>
          <div className="buttons-modal">
            <button onClick={closeModal} className="accept">
              {t('common.accept')}
            </button>
          </div>
        </div>
      </Modal>




      {isModalOpen.modeProject ?
        <ModalVw id="mode-proj-modal" visible={isModalOpen.modeProject}  >
          <ModalContent clases={`bg-white`}>
            <ModalHeader iconClose={true} title="" onClose={() => closeModalVw("#mode-proj-modal", () => setIsModalOpen({ ...isModalOpen, modeProject: false }))} />
            <ModalBody clases={``} >
              <ModeProject
                modal={isModalOpen}
                open={openType}

                onClose={() => closeModalVw("#mode-proj-modal", () => setIsModalOpen({ ...isModalOpen, modeProject: false }))} />
            </ModalBody>
          </ModalContent>
        </ModalVw> : null}


      {isModalOpen.newProjectGenAi ?
        <ModalVw id="projectgenai-modal" visible={isModalOpen.newProjectGenAi}  >
          <ModalContent clases={`bg-white`}>
            <ModalHeader iconClose={true} title="" onClose={() => closeModalVw("#projectgenai-modal", () => setIsModalOpen({ ...isModalOpen, newProjectGenAi: false }))} />
            <ModalBody clases={``} >
              <ProjectViewGenAi
                modal={isModalOpen}
                onClose={() =>
                  closeModalVw("#projectgenai-modal", () => setIsModalOpen({ ...isModalOpen, newProjectGenAi: false }))} />
            </ModalBody>
          </ModalContent>
        </ModalVw> : null}

      {isModalOpen.newProject ?
        <ModalVw id="project-modal" visible={isModalOpen.newProject}  >
          <ModalContent clases={`bg-white`}>
            <ModalHeader iconClose={true} title="" onClose={() => closeModalVw("#project-modal", () => setIsModalOpen({ ...isModalOpen, newProject: false }))} />
            <ModalBody clases={``} >
              <NewProjectView
                modal={isModalOpen}
                onClose={() =>
                  closeModalVw("#project-modal", () => setIsModalOpen({ ...isModalOpen, newProject: false }))} />
            </ModalBody>
          </ModalContent>
        </ModalVw> : null}

      {isModalCampOpen.cam &&
        <ModalVw id="newcp-modal" visible={isModalCampOpen.cam}  >
          <ModalContent clases={`bg-white`}>
            <ModalHeader iconClose={true} title="" onClose={() => closeModalVw("#newcp-modal", () => setIsModalCampOpen({ ...isModalCampOpen, cam: false }))} />
            <ModalBody clases={``} >
              <NewCampaingModal isModalOpen={isModalCampOpen} closeModal={() => closeModalVw("#newcp-modal", () => setIsModalCampOpen({ ...isModalCampOpen, cam: false }))} />
            </ModalBody>
          </ModalContent>
        </ModalVw>}

      {isModalOpen.newSubCampaing &&
        <ModalVw id="sbnewcp-modal" visible={isModalOpen.newSubCampaing}  >
          <ModalContent clases={`bg-white`}>
            <ModalHeader iconClose={true} title="" onClose={() => closeModalVw("#sbnewcp-modal", () => setIsModalOpen({ ...isModalOpen, newSubCampaing: false }))} />
            <ModalBody clases={``} >
              <NewSubCampaingModal isModalOpen={isModalOpen} closeModal={() => { closeModalVw("#sbnewcp-modal", () => setIsModalOpen({ ...isModalOpen, newSubCampaing: false })) }} />
            </ModalBody>
          </ModalContent>
        </ModalVw>}


      {isModalCampOpen.edit &&
        <ModalVw id="campedit-modal" visible={isModalCampOpen.edit}  >
          <ModalContent clases={`bg-white`}>
            <ModalHeader iconClose={true} title="" onClose={() => { closeModalVw("#campedit-modal", () => setIsModalCampOpen({ ...isModalCampOpen, edit: false })) }} />
            <ModalBody clases={``} >
              <EditCampaingModal isModalOpen={isModalCampOpen} closeModal={() => { closeModalVw("#campedit-modal", () => setIsModalCampOpen({ ...isModalCampOpen, edit: false })) }} />
            </ModalBody>
          </ModalContent>
        </ModalVw>}

      {isModalOpen.edit &&
        <ModalVw id="sbcampedit-modal" visible={isModalOpen.edit}  >
          <ModalContent clases={`bg-white`}>
            <ModalHeader iconClose={true} title="" onClose={() => closeModalVw("#sbcampedit-modal", () => setIsModalOpen({ ...isModalOpen, edit: false }))} />
            <ModalBody clases={``} >
              <EditSubCampaingModal isModalOpen={isModalOpen} closeModal={() => { closeModalVw("#sbcampedit-modal", () => setIsModalOpen({ ...isModalOpen, edit: false })) }} />
            </ModalBody>
          </ModalContent>
        </ModalVw>}

      {/* {isModalCampOpen.edit && 
        <ModalVw id="newcpedit-modal" visible={isModalCampOpen.edit}  >
          <ModalContent clases={`sm:w-[80%] md:w-[80%] lg:w-[70%] xl:w-[55%] 2xl:w-1/3  w-[27%]  bg-white`}>
            <ModalHeader title="" onClose={() => closeModalVw("#newcpedit-modal", () => setIsModalOpen({ ...isModalCampOpen.edit, edit: false }))} />
            <ModalBody clases={``} >
            <EditCampaingModal isModalOpen={isModalCampOpen.edit} closeModal={closeModalCamp} /> 
            </ModalBody>
          </ModalContent>
        </ModalVw> } */}

      {/* {isModalCampOpen && <EditCampaingModal isModalOpen={isModalCampOpen} closeModal={closeModalCamp} />} */}
      {/* {isModalOpen && <NewSubCampaingModal isModalOpen={isModalOpen} closeModal={closeModal} />} */}
      {/* {isModalOpen && <EditSubCampaingModal isModalOpen={isModalOpen} closeModal={closeModal} />} */}

      <Tutor steps={tutorialSteps} viewKey="HomeGenAI" />
    </>
  )
}

export default HomeGenAI;